import { useTranslation } from "react-i18next";
import { SIMPLVmTable } from "../../SimplVmTable";

export const SimplVmPostProvisioning = () => {
  const { t } = useTranslation();
  return (  
  <SIMPLVmTable
    type="post-provisioning-operations"
    addButtonLabel={t("AddPost")}
    addModalTitle={t("PostProviosingManagment")} 
    LoadingTitle={t("LoadingPostProvisioning")}
    contentLabel={t("Commands")}
    contentMessage={t("Commands are required")}
    placeholder={t("Commands")}
    messageRequired={t("MessagesCommandsRequired")}
  />
  );
}